export function formatNullableCount(
	value: number | null | undefined,
	options?: Intl.NumberFormatOptions,
): string {
	return value == null ? "—" : Intl.NumberFormat(undefined, options).format(value);
}
